<template>
    <CustomHeader v-if="!isComponentUse" :text="$t('common.deposite')" :hideBacKIcon="footerSelected != '1'"
        @close-popup="backNavigate" :show-fund="true" @go-to-fund="goToFund" />
    <div class="deposit_container" v-if="!display_qr">
        <van-tabs v-model:active="activeTab" class="custom_theme_tabs" :border="false">
            <van-tab>
                <template #title>
                    <div class="tab_title_box">
                        {{ $t('common.paymentChannel') }}
                    </div>
                </template>

                <van-tabs :model-value="props.dataSet.activeChannel.id" class="inner_channel_tabs" :border="false"
                    type="card" @click-tab="handleTabClick" swipe-threshold="4">
                    <van-tab v-for="item in dataSet.channelList" :key="item.id" :title="item.name" :name="item.id" />
                </van-tabs>
            </van-tab>
        </van-tabs>
        <div
            v-if="props.dataSet.activeChannel.channelType == '3' || props.dataSet.activeChannel.channelType == '4' || props.dataSet.activeChannel.channelType == '5'">
            <div class="line"></div>
            <ErcCard :address="props.dataSet.ercCode" :minAmount="props.dataSet.minErcAmount"
                :maxAmount="props.dataSet.maxErcAmount" :typeTitle="props.dataSet.activeChannel.name" />
        </div>
        <div v-else>
            <div class="line"></div>
            <div class="bonus_select">
                <van-checkbox v-model="selecTopup">{{ $t('deposit.promotions') }}</van-checkbox>
            </div>
            <div class="deposit_notice">
                <img src="@/assets/loginRegister/notice.png" alt="">
                {{ $t('deposit.bonuseRedeem') }} {{ dataSet.turnOverValue }}x {{ $t('deposit.invoicing') }}
            </div>
            <div class="sub_container">
                <InputField v-model="selectedAmount" :labelText="dataSet.min_amount + ' - ' + dataSet.max_amount"
                    :isTopupVisible="selecTopup" :giftAmount="dataSet.giftAmount" />
                <div v-if="dataSet.activeChannel.channelType == '7' || dataSet.activeChannel.channelType == '2'">
                    <div class="input_field">
                        <div class="inputLabel">CPF ID</div>
                        <van-field v-model="cpfID" type="number" :placeholder="$t('withdraw.cpfIdPlaceholder')">
                            <template #right-icon>
                                <div class="right-wrapper">
                                    <van-icon v-if="cpfID" name="clear" class="custom-clear" @click.stop="onClear" />
                                    <van-icon name="credit-pay" />
                                </div>
                            </template>
                        </van-field>
                    </div>
                    <div class="errorText" v-if="dataSet.showCPFIdError">
                        {{ $t('withdraw.cpfErrorText') }}</div>
                </div>

                <van-row class="amount_card_list">
                    <van-col span="8" v-for="item in dataSet.amountList" :key="item.fillValue" style="padding: 5px;">
                        <AmountCard :amount="item.fillValue" :isActiveAmount="dataSet.selectedAmount == item.fillValue"
                            :giftRatio="item.giftRatio" :isTopupVisible="selecTopup"
                            @handleCardClick="selectAmountCard(item)" />
                    </van-col>
                </van-row>

                <van-row class="note_text" v-if="selecTopup">
                    <van-col span="4">
                        <img src="@/assets/deposit/deposit_bonus.png" alt="">
                    </van-col>
                    <van-col span="20"> {{ $t('common.deposite') }} R$ {{ formatCurrency(selectedAmount) }} {{
                        $t('deposit.receive') }}
                        R$
                        {{ formatCurrency(dataSet.giftAmount) }}
                        {{ $t('deposit.asaGift') }}.</van-col>
                </van-row>
            </div>

 
            <div class="btn_container">
                <MainButton :title="$t('common.deposite')" :activeStatus="dataSet.isFillField" @click="confirmDeposit"
                    :radius="'10'" />
            </div>
          <div v-if="userStore.isEnableRechargeNotice && dataSet.activeChannel.rechargeNotice" class="descriptionContainer">
            <div class="noticeText">{{ $t('common.notice') }}</div>
           <div v-html="dataSet.activeChannel.rechargeNotice"></div>
        </div>

        </div>
    </div>
    <div v-else >
        <QRPage :show="display_qr" :iframeUrl="iframeUrl" :selectedAmountVal="amountValue" @close="display_qr = false"
            @goTo="goToFund" />
    </div>
    <div v-if="userStore.footerComponent && footerSelected != '1'">
        <MainFooter :itemData="userStore.footerComponent" :activeFooter="2" />
    </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';
import InputField from './components/inputField.vue';
import AmountCard from './components/amountCard.vue';
import { PayChannel } from '@/types/common';
import { formatCurrency } from '@/utils/commonFunction';
import { useUserStore } from '@/stores/user';
import { DepositData } from '@/view/deposit/supportScript';
import MainButton from '../../themeThree/components/common/mainButton.vue';
import CustomHeader from '../components/common/customHeader.vue';
import { useRouter } from 'vue-router';
import ErcCard from '@/themes/themeThree/deposit/components/ercCard.vue';
import QRPage from './components/QRPage.vue';
import MainFooter from '../components/common/mainFooter.vue';
const props = defineProps<{
    dataSet: DepositData
    isComponentUse?: boolean
}>()
const selecTopup = ref(props.dataSet.selecTopup)
const selectedAmount = ref(props.dataSet.selectedAmount)
const footerSelected = localStorage.getItem('showDepositBackIcon')
const amountValue = ref()
const cpfID = ref(props.dataSet.cpfID)
const userStore = useUserStore()
const router = useRouter()
const emit = defineEmits(['selectChannel', 'updateSelecTopup', 'updateSelectedAmount', 'updateCpfID', 'selectAmountCard', 'confirmDeposit'])
const activeTab = ref(0);
const display_qr = ref(false);
const selectChannel = (item: PayChannel) => {
    console.log("Test")
    emit('selectChannel', item)
}
watch(selecTopup, (val) => {
    emit('updateSelecTopup', val)
})
watch(selectedAmount, (val) => {
    emit('updateSelectedAmount', val)
})
watch(cpfID, (val) => {
    emit('updateCpfID', val)
})
watch(() => props.dataSet, (newVal) => {
    selectedAmount.value = newVal.selectedAmount
}, { deep: true, immediate: true })

const selectAmountCard = (select: any) => {
    selectedAmount.value = select.fillValue
    emit('selectAmountCard', select)
}
const confirmDeposit = () => {
    emit('confirmDeposit')
}
const onClear = () => {
    cpfID.value = ''
}
const backNavigate = () => {
    userStore.setRechargeBonusType(0)
    userStore.setTakeFirstDeposit(false)
    router.go(-1)
    localStorage.setItem('showDepositBackIcon', '0')
}
const goToFund = () => {
    router.replace({ path: '/fundsHistory', query: { tabIndex: 0 } })
}
const iframeUrl = ref('')
const triggerConfirm = (url: string) => {
    display_qr.value = true
    iframeUrl.value = url
    amountValue.value = selectedAmount.value
}

const handleTabClick = (tabObject: any) => {
    const id = tabObject.name;
    const selected = props.dataSet.channelList.find(item => String(item.id) === String(id));
    if (selected) {
        emit('selectChannel', selected);
    }
};
onMounted(() => {
    const footerPopupOpen = localStorage.getItem('footerPopupOpen')
    if (footerPopupOpen == '2') {
       localStorage.setItem('showDepositBackIcon', '0')
    }
})
defineExpose({
    triggerConfirm
})

</script>
<style scoped>
.deposit_container {
    background: #090F1F;
    display: flex;
    /* justify-content: center; */
    padding: 60px 0 70px 0;
    flex-direction: column;
    font-size: 20px;
    min-height: 100dvh;
    box-sizing: border-box;
}

.channel_text {
    color: #ffffffd9;
    font-size: 14px;
    padding-top: 15px;
    padding-left: 25px;
}

.channel_list {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    white-space: nowrap;
    padding: 15px 0px;
}

.channel_list::-webkit-scrollbar {
    display: none;
}

.channel_card {
    border-radius: 5px;
    width: 70px;
    color: #ffffff;
    background-color: #ffffff26;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    padding: 7px;
    margin-right: 10px;
    font-size: 15px;
    height: 35px;
    width: 100%;
}

.active_channel {
    background: linear-gradient(180deg, #35A5F8 0%, #0268CB 100%);
    color: #ffffff;
    border-radius: 5px;
}

.deposit_notice {
    display: flex;
    align-items: center;
    border-radius: 5px;
    color: #ffffffa6;
    font-size: 14px;
    margin: 0px 25px 0;
    background-color: #ffffff26;
    padding: 15px;
}

.deposit_notice img {
    width: 20px;
    opacity: 0.5;
    height: 20px;
    padding-right: 10px;
}

.amount_card_list {
    padding: 15px 0;
}

.btn_container {
    padding: 30px 60px;
}

.bonus_select {
    padding: 15px 25px 15px;
}

.bonus_select>>>.van-checkbox__label {
    color: #ffffff73;
    font-size: 14px;
}

.bonus_select>>>.van-checkbox__icon--round {
    font-size: 15px;
    background: #fff;
    border-radius: 30px;
}

.bonus_select>>>.van-checkbox__icon--checked .van-icon {
    background-color: #0268CB !important;
    border-color: #0268CB !important;
}

.note_text {
    padding: 10px;
    border-radius: 10px;
    background-color: #ffffff14;
    font-size: 12px;
    color: #ffffffa6;
}

.note_text .van-col {
    display: flex;
    align-items: center;
}

.note_text img {
    width: 35px;
}

.line {
    /* height: 1.5px; */
    /* background: #1a233e; */
    margin: 0 15px; 
}

.sub_container {
    padding: 0 25px;
}

.sub_container ::v-deep .van-field {
    border-radius: 10px;
    padding: 2vh !important
}

.btn_container ::v-deep .defaultButton .van-button--default {
    border-radius: 10px !important;
    padding: 1.5vw 0;
}

.amount_card {
    border-radius: 5px;
}

.input_field>>>.van-field {
    border-radius: 10px;
    background-color: #101629 !important;
    color: #ffffffd9;
    padding: 12px 20px !important;
    margin-top: 10px;
}

.input_field>>>.van-field__control {
    color: #ffffffa6 !important;
    font-size: 12px;

}

.input_field {
    padding: 10px 0;
}

.inputLabel {
    color: #ffffffd9;
    font-size: 14px;
    margin-left: 10px;
}

.errorText {
    color: red;
    font-size: 12px;
}

.right-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
}

.descriptionContainer {
    padding: 15px;
    background: #ffffff2f;
    font-size: 14px;
    color: #fff;
    border-radius: 10px;
    margin: 15px 20px;
}

.noticeText {
    font-size: 14px;
    font-weight: bold;
    padding: 0 0 5px;
    color: #ffffffa6;
}

div :deep(p) {
    margin-bottom: 10px;
    margin-top: 0px;
    color: #fff;
    line-height: 1.5;
}

div :deep(br) {
    content: "";
    margin: 5px 0;
    display: block;
}

.custom_theme_tabs {
    padding: 0 15px;
}

.custom_theme_tabs :deep(.van-tabs__nav) {
    background-color: transparent;
    padding: 0;
    height: 60px;
}

.custom_theme_tabs :deep(.van-tab--active) {
    background-color: transparent !important;
    color: #fff !important;
    font-weight: bold;
}

.custom_theme_tabs> :deep(.van-tabs__wrap) .van-tab--active::after {
    content: "";
    position: absolute;
    bottom: 0;
    /* left: 15%; */
    width: 100%;
    height: 2px;
    /* background: linear-gradient(0deg, #0a72d2, #2f9df2); */
    border-radius: 2px;
}

.inner_channel_tabs :deep(.van-tabs__wrap) {
    border: none;
    display: flex;
    align-items: center;
    flex-shrink: 0;
}


.custom_theme_tabs :deep(.van-tab) {
    color: #ffffffa6;
    font-size: 17px;
    /* padding: 0 25px; */
    flex: none;
}

.custom_theme_tabs :deep(.van-tabs__line) {
    background-color: transparent;
    height: 1px;
    /* width: 40% !important; */
    bottom: 0;
}

.custom_theme_tabs :deep(.van-tabs__wrap) {
    height: 60px;
    /* border-bottom: 1px solid #1a233e; */
}

.inner_channel_tabs :deep(.van-tabs__nav--card) {
    border: none;
    background: transparent;
    margin: 15px 0;
    height: auto;
}

.inner_channel_tabs :deep(.van-tab) {
    background-color: #ffffff26;
    color: #ffffff;
    border: none;
    margin-right: 10px;
    border-radius: 5px;
    padding: 0 10px;
    height: 45px;
    line-height: 35px;
    min-width: 80px;
    flex: none;
}

.inner_channel_tabs :deep(.van-tab--active) {
    background: linear-gradient(180deg, #35A5F8 0%, #0268CB 100%) !important;
    color: #ffffff !important;
}

.inner_channel_tabs :deep(.van-tabs__wrap) {
    border: none;
}

@media (min-width: 1440px) {


    .deposit_notice {
        padding: 15px;
    }
}

@media (min-width: 1920px) {

    .channel_text,
    .channel_card,
    .balance_text,
    .sub_container,
    .deposit_notice,
    .sub_container ::v-deep .van-field,
    .btn_container ::v-deep .defaultButton .van-button--default,
    .amount_card,
    .bonus_select ::v-deep .van-checkbox__label,
    .active_channel {
        font-size: 2.15vh !important;
    }

    .deposit_notice {
        padding: 15px;
    }
}

@media (max-width: 360px) {


  .custom_theme_tabs {
    padding: 0 10px;
  }

  .custom_theme_tabs :deep(.van-tabs__wrap) {
    height: 45px;
  }

  .custom_theme_tabs :deep(.van-tab) {
    font-size: 14px;
  }

  .inner_channel_tabs :deep(.van-tab) {
    height: 36px;
    line-height: 28px;
    min-width: 60px;
    font-size: 12px;
    padding: 0 8px;
  }

  .sub_container {
    padding: 0 15px;
  }
  
  .sub_container :deep(.van-field){
    padding : 8px !important
  }

  .deposit_notice {
    font-size: 12px;
    padding: 10px;
    margin: 0 15px;
  }

  .deposit_notice img {
    width: 16px;
    height: 16px;
  }

  .bonus_select {
    padding: 10px 15px;
  }

  .inputLabel {
    font-size: 12px;
  }

  .input_field>>>.van-field {
    padding: 8px 12px !important;
    font-size: 12px;
  }

  .amount_card_list {
    padding: 10px 0;
  }

  .amount_card {
    font-size: 12px;
  }

  .btn_container {
    padding: 20px;
  }

  .note_text {
    font-size: 11px;
  }

  .note_text img {
    width: 25px;
  }
}
</style>